import { tunnelCells } from './signature';
import type { HeroDefinition } from '../types';

/** Burrow — clear one row or one column. A drag picks the tunnel. */
export const bramble: HeroDefinition = {
  id: 'bramble',
  name: 'Bramble',
  species: 'badger',
  classId: 'infiltration',
  powerName: 'Burrow',
  color: 'leaf',
  description: 'Clears a row or a column.',
  target: 'line',
  paw: 'cc_hero_bramble_paw@1x.png',
  apply(state, _player, target, aim) {
    const axis = aim?.axis === 'row' ? 'row' : 'column';
    const index = axis === 'row' ? (target?.r ?? 0) : (target?.c ?? 0);
    return { clear: tunnelCells(state, axis, index), convert: [] };
  },
};
